import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScoreDelayService {
  private httpClient = inject(HttpClient);
  
  // Transfer match
  updateScoreDelay(matchId, scoreDelay) {
    return this.httpClient.post<any>('api_endpoint' + '/match/update-score-delay', { matchId, scoreDelay});
  }

}
